// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const Type = {
    alias: (value) => {
        return Object.assign(Object.assign({}, value), { type: "alias", _visit: function (visitor) {
                return FernIr.Type._visit(this, visitor);
            } });
    },
    enum: (value) => {
        return Object.assign(Object.assign({}, value), { type: "enum", _visit: function (visitor) {
                return FernIr.Type._visit(this, visitor);
            } });
    },
    object: (value) => {
        return Object.assign(Object.assign({}, value), { type: "object", _visit: function (visitor) {
                return FernIr.Type._visit(this, visitor);
            } });
    },
    union: (value) => {
        return Object.assign(Object.assign({}, value), { type: "union", _visit: function (visitor) {
                return FernIr.Type._visit(this, visitor);
            } });
    },
    undiscriminatedUnion: (value) => {
        return Object.assign(Object.assign({}, value), { type: "undiscriminatedUnion", _visit: function (visitor) {
                return FernIr.Type._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "alias":
                return visitor.alias(value);
            case "enum":
                return visitor.enum(value);
            case "object":
                return visitor.object(value);
            case "union":
                return visitor.union(value);
            case "undiscriminatedUnion":
                return visitor.undiscriminatedUnion(value);
            default:
                return visitor._other(value);
        }
    },
};
